import { Loader, Toast, ToastsContainer } from "components";
import FeedbackButton from "components/FeedbackButton";
import { AuthContext } from "context/auth";
import { FeatureFlagContext } from "context/featureFlags";
import { LabContext } from "context/labs";
import { ToastContext } from "context/toast";
import { API } from "helpers/api";
import { useEffect, useState } from "react";
import AppRouter from "routes/AppRouter";
import Routes from "routes/Routes";
import { useStoreContext } from "utils/GlobalState";
import { GET_USEROBJECT } from "utils/actions";

import "theme/font.css";
// import { UserStoreProvider } from "utils/GlobalState";

export default function App() {
  const [toastList, setToastList] = useState([]);
  const [selectedLab, setSelectedLab] = useState(null);
  const [features, setFeatures] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const { state, dispatch } = useStoreContext();
  const { userObject } = state;

  // On app load, check if user is authenticated
  useEffect(() => {
    API({ endpoint: "/user", method: "GET" })
      .then((response) => {
        if (response?.ok && response?.result) {
          dispatch({
            type: GET_USEROBJECT,
            userObject: { ...response.result },
          });
        }
        setAuthChecked(true);
      })
      .catch(() => {
        setAuthChecked(true);
      });
  }, [dispatch]);

  useEffect(() => {
    if (userObject && userObject.id) {
      API({ endpoint: "/feature-flags/for-user/enabled", method: "GET" })
        .then((response) => setFeatures(response.result ? response.result : []))
        .catch((error) => {
          console.log("Error encountered", error);
          setFeatures([]);
        });
      API({ endpoint: "/visits/log", method: "post" }).catch((error) => {
        console.log(error);
      });
    }
  }, [userObject]);

  // Associate GA events/sessions with the logged-in user
  useEffect(() => {
    if (userObject && userObject.id && typeof window.gtag === "function") {
      window.gtag("set", { user_id: String(userObject.id) });
    }
  }, [userObject]);

  // Exclude internal Grace Papers staff from Google Analytics tracking
  useEffect(() => {
    if (!window.__GA_MEASUREMENT_ID) return;
    const email = userObject?.email || userObject?.account_email || "";
    const isInternalUser = email.toLowerCase().endsWith("@gracepapers.com.au");
    window[`ga-disable-${window.__GA_MEASUREMENT_ID}`] = isInternalUser;
  }, [userObject]);

  const showToast = ({ type, title, message, timer }) => {
    const toastId = Math.floor(Math.random() * 1000 + 1);

    const newToast = {
      id: toastId,
      type: type,
      title: title,
      message: message,
      timer: timer,
    };

    setToastList([...toastList, newToast]);
  };

  const closeToast = (id) => {
    const index = toastList.findIndex((e) => e.id === id);
    toastList.splice(index, 1);

    setToastList([...toastList]);
  };

  const setLab = (lab) => {
    setSelectedLab(lab);
  };

  // Only render routes after auth check
  if (!authChecked) {
    return <Loader />;
  }

  return (
    <AuthContext.Provider value={{ userObject }}>
      <FeatureFlagContext.Provider value={{ features }}>
        <ToastContext.Provider
          value={{ showToast: showToast, closeToast: closeToast }}
        >
          {toastList ? (
            <ToastsContainer>
              {toastList.map((t) => {
                return (
                  <Toast
                    key={t.id}
                    id={t.id}
                    type={t.type}
                    title={t.title}
                    message={t.message}
                    timer={t.timer}
                  />
                );
              })}
            </ToastsContainer>
          ) : null}
          {userObject && userObject.id ? (
            features === null ? (
              <Loader />
            ) : (
              <LabContext.Provider value={{ setLab, selectedLab }}>
                <AppRouter />
              </LabContext.Provider>
            )
          ) : (
            <Routes />
          )}
          <FeedbackButton />
        </ToastContext.Provider>
      </FeatureFlagContext.Provider>
    </AuthContext.Provider>
  );
}
